document.addEventListener("DOMContentLoaded", ()=>{
    /*
    if(document.querySelectorAll(".Collection_Sidebar ul li").length > 0 && window.innerWidth < 1024){
      document.querySelectorAll(".Collection_Sidebar ul li a").forEach((el)=>{
        el.href += "#Products_Section";
      })
    }
    */

    const categorySelector = document.querySelector('.Collection_Sidebar select');

    if(categorySelector){
        categorySelector.addEventListener('change', (e) => {
            window.location.href = e.target.value;
        });
    }

  
    const loadMoreButton = document.querySelector('.Load_More');

    if(!loadMoreButton){
        return;
    }

    if(loadMoreButton){
        loadMoreButton.addEventListener('click', (e) => {
            e.preventDefault();

            const totalPages = parseInt(loadMoreButton.dataset.totalPages);
            const currentPage = parseInt(loadMoreButton.dataset.currentPage) + 1;
            const nextUrl = loadMoreButton.dataset.nextUrl.replace(/page=[0-9]+/,'page='+ currentPage);

            console.log(nextUrl);

            // Get products from next page
            fetch(nextUrl)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newProducts = doc.querySelectorAll('.Collection_Grid .Collection_Product');

                    // Append new products
                    const grid = document.querySelector('.Collection_Grid');
                    newProducts.forEach((product) => {
                        grid.appendChild(product);
                    });
                    window.dispatchEvent(new CustomEvent('global:align'));

                    // Update current page
                    loadMoreButton.dataset.currentPage = currentPage;

                    // Hide button if last page
                    if(currentPage >= totalPages){
                        loadMoreButton.style.display = 'none';
                    }
                });
        });
    }
});